/** @format */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomAttainmentApplication, CustomAttainmentWorkflowApplication, OtmId } from 'common-typescript/types';
import { AuthService } from 'sis-common';
import { AlertsService, FileItem, getLabelState, required, SisFormBuilder } from 'sis-components';

@Component({
    selector: 'app-caa-confirmation',
    templateUrl: './caa-confirmation.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CaaConfirmationComponent implements OnInit {
    @Input() application: Partial<CustomAttainmentApplication | CustomAttainmentWorkflowApplication>;
    @Input() attachments: FileItem[];
    @Input() disableButtons = false;
    @Output() exit = new EventEmitter<void>();
    @Output() previous = new EventEmitter<void>();
    @Output() submit = new EventEmitter<Partial<CustomAttainmentApplication>>();

    mustPrintDecision: FormControl;

    getLabelState = getLabelState;
    readonly studentId: OtmId;

    constructor(
        authService: AuthService,
        private alertsService: AlertsService,
        private fb: SisFormBuilder,
    ) {
        this.studentId = authService.personId();
    }

    ngOnInit(): void {
        this.mustPrintDecision = this.fb.control(this.application?.mustPrintDecision ?? null, required());
    }

    onSubmit(): void {
        if (this.mustPrintDecision.valid) {
            this.submit.emit({ mustPrintDecision: this.mustPrintDecision.value });
        } else {
            this.mustPrintDecision.markAsTouched();
            this.alertsService.addFormSubmissionFailureAlert();
        }
    }
}
